export default __webpack_public_path__ + "static/media/twitter-logo.032a50e9.svg";